import { ColumnMapping } from "./types";

const getRowValue = (row: Record<string, unknown>, colLabel: string | undefined) =>
   colLabel ? row[colLabel] : undefined;

const toText = (value: unknown): string => (value == null ? "" : String(value).trim());

const toNumber = (value: unknown): number => {
   const parsed = Number(value);
   return Number.isFinite(parsed) ? parsed : 0;
};

export const buildExternalSummaries = (data: Record<string, unknown>[], mapping: ColumnMapping) =>
   data
      .filter((row) => {
         const id = toText(getRowValue(row, mapping.id));
         const name = toText(getRowValue(row, mapping.indicator_name));
         return id !== "" && name !== "";
      })
      .map((row) => ({
         id: toText(getRowValue(row, mapping.id)),
         columnKey: toText(getRowValue(row, mapping.indicator_name)),
         titleTranslationKey: toText(getRowValue(row, mapping.indicator_name)),
         valuePrefix: toText(getRowValue(row, mapping.indicator_prefix)),
         valueSuffix: toText(getRowValue(row, mapping.indicator_suffix)),
         valueLimit: toNumber(getRowValue(row, mapping.indicator_completion_value)),
         valueLimitDescriptionTranslationKey: toText(
            getRowValue(row, mapping.indicator_completion_prefix),
         ),
         indicatorValue: toText(getRowValue(row, mapping.indicator_value)),
         indicatorCompletionPercent: toNumber(
            getRowValue(row, mapping.indicator_completion_percent),
         ),
         indicatorCompletionSuffix: toText(getRowValue(row, mapping.indicator_completion_suffix)),
         linkToBoard: toText(getRowValue(row, mapping.indicator_board_link)),
      }));
